import React from 'react'
import { Outlet, useOutletContext } from "react-router-dom";
import Sidebar from './Components/Sidebar'
import { ToastContainer } from 'react-toastify'
// import { Header } from 'antd/es/layout/layout'
import Header from './Components/Header';

const PrivateLayout = () => {

    const { userData } = useOutletContext();
    return (
        <div className="Thrillion-full-page">
            <Sidebar userData={userData}/>
            <div className="thrillion-main-content">
                <Header />
                <ToastContainer
                    closeOnClick={true}
                    pauseOnHover={true}
                    toastStyle={{ color: 'white', backgroundColor: 'black' }}
                />
                <Outlet context={{ userData }} />
            </div>
        </div>
    )
}

export default PrivateLayout
